<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 32"
  >
    <g>
      <path
        fill="#010F37"
        d="M23.114
      6.124l-5.241-5.24c-0.542-0.545-1.292-0.882-2.121-0.883h-12.754c-1.656
      0.007-2.997 1.35-2.999 3.006v25.995c0.001 1.656 1.343 2.998 2.999
      2.999h17.996c1.656-0.001 2.998-1.343
      2.999-2.999v-20.752c-0.001-0.83-0.337-1.581-0.879-2.125l0 0zM21.701
      7.542c0.125 0.123 0.216 0.28 0.261 0.455l0.001 0.007h-5.966v-5.966c0.182
      0.046 0.339 0.138 0.462 0.262l0 0zM20.995
      30.001h-17.996c-0.551-0.002-0.997-0.448-1-0.999v-25.995c0.001-0.552
      0.448-0.999 0.999-1.002h10.999v6.5c0 0.001 0 0.003 0 0.004 0 0.826 0.67
      1.496 1.496 1.496 0.001 0 0.003 0 0.004 0h6.498v18.996c-0.002 0.552-0.45
      0.998-1.001 1h-0zM17.996 14.751v0.501c-0.001 0.413-0.336 0.748-0.749
      0.749h-10.499c-0.413-0.001-0.748-0.336-0.749-0.749v-0.501c0.001-0.413
      0.336-0.748 0.749-0.749h10.499c0.413 0.001 0.748 0.336 0.749
      0.749v0zM17.996 18.749v0.501c-0.001 0.413-0.336 0.748-0.749
      0.749h-10.499c-0.413-0.001-0.748-0.336-0.749-0.749v-0.497c0.001-0.413
      0.336-0.748 0.749-0.749h10.499c0.413 0.001 0.748 0.336 0.749
      0.749v0zM17.996 22.748v0.501c-0.001 0.413-0.336 0.748-0.749
      0.749h-10.499c-0.413-0.001-0.748-0.336-0.749-0.749v-0.501c0.001-0.413
      0.336-0.748 0.749-0.749h10.499c0.414 0.001 0.749 0.337 0.749 0.751 0 0.001
      0 0.001 0 0.002v-0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
